// extracted by mini-css-extract-plugin
export default {"root":"index__root--K34Z7"};